import ShippingServices from '@root/modules/Sellers/Shipping/services/shipping';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import {
  AutoComplete,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select
} from 'antd';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import useOnclickOutside from 'react-cool-onclickoutside';
import ProductService from '../../Product/services/product';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { ShippingFormData } from '../interfaces';
import useDebounce from '@root/core/hooks/useDebounce';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from 'use-places-autocomplete';
import { AutocompletePrediction } from 'react-places-autocomplete';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import metaApi from '@root/core/components/CountryPhoneInput/meta-service';
import CommentTabsComponent from '@root/core/components/CommentTabs';
import {
  CommentGroup,
  CommentList,
  CommentTabs,
  CommentType,
  CreateComment
} from '@root/core/components/CommentTabs/interface';
import commentService from '@root/core/components/CommentTabs/commentService';
import { placesAutocomplete } from '@root/utils/helpers/placesAutocomplete';
import { downloafFile, getStatusSeller } from '../helpers';

const ShippingDetail = () => {
  const [info, setInfo] = useState<{
    updated_at: string;
    status: string;
    name: string;
    courier: string;
    trackingNumber: string;
    commentWarehouse: string;
  }>({
    updated_at: '',
    status: '',
    name: '',
    courier: '',
    trackingNumber: '',
    commentWarehouse: ''
  });
  const history = useHistory();
  const [suggestProduct, setSuggestProduct] = useState([] as any);
  const { shippingid }: any = useParams();
  const [warehouseId, setWarehouseId] = useState(0);
  const [form] = Form.useForm<ShippingFormData>();
  const [inputProduct, setInputProduct] = useState('');
  const [remainQuantity, setRemainQuantity] = useState<number[]>([0, 0]);
  const [indexProduct, setIndexProduct] = useState(0);
  const [channel, setChannel] = useState<string>('');
  const [selectUse, setSelectUse] = useState(true);
  const [searchValue, setSearchValue] = useState<string>('');
  // const [onload, setOnload] = useState<boolean>(false);
  const [countryCode, setCountryCode] = useState<string>('');
  const [callingCode, setCallingCode] = useState<string>('');
  const [commentList, setCommentList] = useState<CommentList>();
  const [tabs, setTabs] = useState<CommentTabs[]>([]);
  const [isDownload, setIsDownload] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [returnExists, setReturnExists] = useState(false);
  const shippingDetailRef = useRef<any>();

  const packageMethod = [
    'Unnecessary',
    'Carton box',
    'Poly mailer',
    'Bubble mailer',
    'Compression',
    'Airpack',
    'Icepack',
    'Envelope',
    'Bubble wrap'
  ];
  const listBreadcrumb = [
    {
      tittle: '배송 관리',
      url: '/admin/seller/shipping'
    },
    {
      tittle: '배송 조회',
      url: '/admin/seller/shipping'
    },
    {
      tittle: '배송 상세',
      url: ''
    }
  ];

  const debounced = useDebounce(inputProduct, 1000);

  const {
    suggestions: { status, data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete({
    debounce: 300
  });

  const ref = useOnclickOutside(() => {
    clearSuggestions();
  });

  const handleInput: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (form.getFieldError('detailAddress').length === 0) {
      // setCoordinates({
      //   lat: 0,
      //   lng: 0
      // });
      form.setFieldsValue({
        postalCode: '',
        country: '',
        detailAddress: '',
        shippingAddress: '',
        city: '',
        state: ''
      });
      setValue(e.target.value);
    } else {
      clearSuggestions();
    }
    setSearchValue(e.target.value);
  };

  const renderSuggestions = () =>
    data.map((suggestion: any) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text }
      } = suggestion;
      return (
        <li key={place_id} onClick={handleSelectAddr(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  const handleSelectAddr =
    ({ description }: AutocompletePrediction) =>
    async () => {
      setValue(description, false);
      clearSuggestions();

      const results = await getGeocode({ address: description });
      const { lat, lng } = getLatLng(results[0]);
      // setCoordinates({
      //   lat,
      //   lng
      // });
      setSearchValue(description);
      form.setFieldsValue({
        shippingAddress: description
      });
      const address_components = results[0].address_components;
      const { COUNTRY, ZIP_CODE, TOWN, CITY, STATE, NEAREST_ROAD } =
        placesAutocomplete.getAddressComponent(address_components, [
          'COUNTRY',
          'TOWN',
          'CITY',
          'STATE',
          'ZIP_CODE',
          'NEAREST_ROAD'
        ]);

      form.setFieldsValue({
        detailAddress: results[0].formatted_address.split(',')[0]!,
        country: COUNTRY!,
        postalCode: ZIP_CODE!,
        state: STATE ?? CITY!,
        city: TOWN ?? CITY!,
        street: NEAREST_ROAD!
      });
    };

  const getDetailProduct = async (productId: number) => {
    const detailProduct = await ProductService.getDetailProduct(productId);
    let detailProductSearch = detailProduct.data;
    let formProduct = form.getFieldValue('product');
    formProduct[indexProduct] = {
      id: detailProductSearch.id,
      productName: formProduct[indexProduct].productName ?? '',
      sku: detailProductSearch?.sku,
      eanUpc: detailProductSearch?.eanUpc,
      stockQuantity: 0
    };
    form.setFieldsValue({
      product: formProduct
    });

    let remainQty = Array.isArray(remainQuantity)
      ? JSON.parse(JSON.stringify(remainQuantity))
      : [remainQuantity];
    remainQty[indexProduct] =
      Number(detailProductSearch?.inventory?.remainQuantity ?? 0) ?? 0;
    setRemainQuantity(remainQty);
  };

  const getListProduct = async (productName: string) => {
    if (warehouseId !== 0) {
      let productReset = form.getFieldValue('product');
      productReset[indexProduct] = {
        id: 0,
        productName: inputProduct,
        sku: '',
        eanUpc: '',
        stockQuantity: 0
      };
      form.setFieldsValue({
        product: productReset
      });
      let remain = Array.isArray(remainQuantity)
        ? JSON.parse(JSON.stringify(remainQuantity))
        : [remainQuantity];
      remain[indexProduct] = 0;
      setRemainQuantity(remain);
      const listProduct = await ShippingServices.getProduct(
        warehouseId,
        productName
      );
      let productuse = form
        .getFieldValue('product')
        .map((item: any) => item.id);
      let listProductUse = listProduct.data
        .filter((item: any) => !productuse.includes(item.id))
        .map((ite: any) => {
          return {
            value: ite.productName,
            key: ite.id,
            label: (
              <div
                key={ite.id}
                onClick={() => {
                  let a = form.getFieldValue('product');
                  a[indexProduct].productName = ite.productName;
                  form.setFieldsValue({
                    product: a
                  });
                  getDetailProduct(ite.id);
                  // setIdWarehouse(sug.id)
                  setSuggestProduct([]);
                }}
              >
                <strong>{ite.productName}</strong>
              </div>
            )
          };
        });
      setSuggestProduct(listProductUse);
      // setInputProduct('');
    }
  };

  const getDetail = async () => {
    const detailShipping = await ShippingServices.getDetailShipping(shippingid);
    let packageMethodUse = detailShipping?.data?.packagingMethod ?? '';

    if (!!packageMethodUse) {
      let isNotDirectInput = packageMethodUse
        .split(',')
        .some((item: string) => packageMethod.includes(item));
      if (!!isNotDirectInput) {
        form.setFieldsValue({ packagingMethod: packageMethodUse.split(',') });
      } else {
        setSelectUse(false);
        form.setFieldsValue({
          packagingMethod: ['Directinput'],
          packageInput: packageMethodUse
        });
      }
    }
    shippingDetailRef.current = detailShipping?.data;
    form.setFieldsValue({
      orderNumber: detailShipping?.data?.orderNumber,
      orderDate: moment(detailShipping?.data?.orderDate),
      // orderDate: moment(detailShipping?.data?.orderDate)
      //   .utc(true ?? 9)
      //   .format('YYYY-MM-DD'),
      saleChannel: detailShipping?.data?.saleChannel,
      buyerName: detailShipping?.data?.buyerName,
      buyerEmail: detailShipping?.data?.buyerEmail,
      recipientName: detailShipping?.data?.recipientName,
      recipientPhone: detailShipping?.data?.recipientPhone ?? '',
      shippingAddress: detailShipping?.data?.shippingAddress,
      detailAddress: detailShipping?.data?.detailAddress,
      country: detailShipping?.data?.country,
      postalCode: detailShipping?.data?.postalCode,
      state: detailShipping?.data?.state,
      city: detailShipping?.data?.city,
      detailAddress2: detailShipping?.data?.detailAddress2,
      dangerous: detailShipping?.data?.dangerous ? 'Yes' : 'No',
      shippingMethod: detailShipping?.data?.shippingMethod,
      sellerComment: !!detailShipping?.data?.sellerComment
        ? detailShipping?.data?.sellerComment
        : 'No comment',
      product:
        detailShipping?.data?.orderProducts &&
        detailShipping?.data?.orderProducts.length > 0
          ? detailShipping?.data?.orderProducts.map((item: any) => ({
              id: item.productImported.id,
              productName: item.productImported.productName,
              sku: item.productImported.sku,
              eanUpc: item.productImported.eanUpc,
              asin: item.productImported.asin,
              orderQuantity: item.orderQuantity
            }))
          : []
    });
    setChannel(detailShipping?.data?.saleChannel);
    setCountryCode(
      (detailShipping?.data?.recipientCountryCode ?? '').replace('+', '')
    );
    setInfo({
      updated_at: moment(detailShipping?.data?.updated_at)
        .utc(true ?? 9)
        .format('YYYY-MM-DD hh:mm:ss A '),
      status: !!detailShipping?.data?.sellerStatus
        ? getStatusSeller(detailShipping?.data?.sellerStatus)
        : '',
      name: detailShipping?.data?.orderNumber,
      courier: detailShipping?.data?.courier ?? '',
      trackingNumber: detailShipping?.data?.trackingNumber ?? '',
      commentWarehouse: detailShipping?.data?.warehouseComment ?? ''
    });
    setWarehouseId(detailShipping?.data?.warehouseId);
    setRemainQuantity(
      detailShipping.data.orderProducts.reduce(
        (x: number[], n: any) => [...x, n.orderQuantity],
        []
      )
    );
    setSearchValue(detailShipping?.data?.shippingAddress);
    setReturnExists(detailShipping?.data?.returnExists ?? false);
  };

  const onFinish = async (value: any) => {
    let body: any = form.getFieldsValue();
    body.packagingMethod =
      Array.isArray(body.packagingMethod) &&
      !body.packagingMethod.includes('Directinput')
        ? body.packagingMethod.filter((item: any) => !!item).join()
        : body.packageInput;
    body.orderProducts = form.getFieldValue('product').map((item: any) => ({
      productId: item.id,
      orderQuantity: item.orderQuantity
    }));
    body.dangerous = Number(body.isDangerousProduct);
    // body.sellerStatus = 'Saved';
    delete body.product;
    delete body.packageInput;

    let isProductValid = form
      .getFieldValue('product')
      .every((item: any) => Number(item.orderQuantity) > 0);
    if (!isProductValid) {
      message.error('Please enter quantity of product for create shipping > 0');
      return;
    }

    try {
      await ShippingServices.putUpdateShipping(body, shippingid);
      message.success('Update order success');
    } catch (e) {
      message.error(e);
    }
  };

  const getCallingCode = async () => {
    if (!!countryCode) {
      const responseData = await metaApi['getMetaData']();
      const selected = responseData?.data.country_code.find(
        (item: any) => item.lookupCodeId === countryCode
      );
      setCallingCode(selected?.calling_code);
    }
  };

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
      // setLoading(true);
    }
    const comments = await commentService.getComments({
      group: CommentGroup.DELIVERY_DETAIL,
      itemId: shippingid
    });
    setCommentList(comments);
    if (showLoading) {
      // setLoading(false);
    }
  };

  const removeShipping = async (showLoading?: Boolean) => {
    await ShippingServices.removeShipping(shippingid);
    history.push('/admin/seller/shipping');
  };

  useEffect(() => {
    if (shippingid) {
      getCommentList();
    }
  }, [shippingid]);

  const onSendComment = async (body: CreateComment, id?: number) => {
    // setLoading(true);
    // send comment
    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
    // setLoading(false);
  };

  useEffect(() => {
    getDetail();

    setTabs([
      {
        title: 'Comment',
        type: CommentType.COMMON,
        description: 'Comment from Customer :'
      },
      {
        title: 'Request modify',
        description: 'Reasons for modification from customer :',
        type: CommentType.REQUEST_MODIFY,
        options: []
      },
      {
        title: 'Request delete',
        description: 'Reasons for deletion from Customer :',
        type: CommentType.REQUEST_DELETE,
        options: []
      }
    ]);
  }, []);

  useEffect(() => {
    getListProduct(inputProduct);
  }, [debounced, indexProduct]);

  useEffect(() => {
    getCallingCode();
  }, [countryCode]);

  const onDownloadInvoice = async () => {
    if (!shippingid) {
      return;
    }

    setIsDownload(true);
    const res = await ShippingServices.downloadInvoice({
      orderId: shippingid,
      orderNumber: form.getFieldValue('orderNumber'),
      warehouseId: warehouseId
    });

    if (res.response) {
      setIsShowErrorModal(true);
      setIsDownload(false);

      return;
    }

    const seller = shippingDetailRef.current?.seller;

    const fileName = `${
      seller ? `${seller.companyName}_` : ''
    }${form.getFieldValue('orderNumber')}.pdf`;

    downloafFile(res, fileName);
    setIsDownload(false);
    setIsShowErrorModal(false);
  };

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div>
        <Card
          bordered={false}
          className="admin-card shipping-detail"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              marginTop: '20px',
              paddingBottom: '2rem'
            }}
          >
            <div
              style={{
                display: 'flex',
                padding: '0 1rem',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: 'solid #f0f2f5'
              }}
            >
              <div
                className="button-wrapper"
                style={{ display: 'flex', alignItems: 'center', gap: 5 }}
              >
                <span>
                  <strong>Update Date :</strong> &nbsp;{info.updated_at}
                </span>
                <Button
                  type="default"
                  className="button-import"
                  onClick={onDownloadInvoice}
                  loading={isDownload}
                  size="small"
                >
                  송장 다운로드
                </Button>
              </div>
              <div style={{ padding: '1rem 2rem' }}>
                <Button className="renueProduct">
                  {/* <p style={{ padding: '0 0.5rem' }}>재고 수량 : &nbsp;</p> */}
                  {info.status}
                </Button>
              </div>
            </div>
            <Form
              form={form}
              // onKeyPress={(e) => {
              //   e.key === 'Enter' && e.preventDefault(); }}
              name="basic-form"
              onFinish={onFinish}
              initialValues={{
                orderNumber: '',
                orderDate: '',
                saleChannel: '',
                buyerName: '',
                buyerEmail: '',
                recipientName: '',
                recipientPhone: '',
                shippingAddress: '',
                detailAddress: '',
                country: '',
                postalCode: '',
                product: [],
                packagingMethod: '',
                dangerous: '',
                shippingMethod: '',
                sellerComment: ''
              }}
              layout="vertical"
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                  marginBottom: '1rem'
                }}
              >
                <Form.Item
                  label="주문 번호"
                  name="orderNumber"
                  style={{ justifyItems: 'center', padding: '0 1rem' }}
                  rules={[
                    {
                      required: true,
                      message: '주문번호를 입력해주세요.'
                    }
                  ]}
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="주문 날짜"
                  name="orderDate"
                  style={{ justifyItems: 'center', padding: '0 1rem' }}
                  rules={[
                    {
                      required: true,
                      message: '주문날짜를 선택해주세요'
                    },
                    {
                      type: 'date',
                      message: 'Only enter date'
                    }
                  ]}
                >
                  <DatePicker
                    format={'YYYY.MM.DD'}
                    style={{ width: '100%' }}
                    disabled
                  />
                </Form.Item>
                <Form.Item
                  label="판매 채널"
                  name="saleChannel"
                  style={{ justifyItems: 'center', padding: '0 1rem' }}
                  rules={[
                    {
                      required: true,
                      message: '판매 채널을 선택해주세요'
                    }
                  ]}
                >
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Select"
                    disabled
                  >
                    <Select.Option value="Amazon">Amazon</Select.Option>
                    <Select.Option value="Ebay">Ebay</Select.Option>
                    <Select.Option value="Ratuken">Rakuten</Select.Option>
                    <Select.Option value="QOO10">Qoo10</Select.Option>
                    <Select.Option value="OfficeOnlineMall">
                      Office Online Mall
                    </Select.Option>
                    <Select.Option value="Others">Others</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                  marginBottom: '1rem'
                }}
              >
                <Form.Item
                  label="구매자 이름"
                  name="buyerName"
                  style={{ justifyItems: 'center', padding: '0 1rem' }}
                  rules={[
                    {
                      required: true,
                      message: '구매자 이름을 입력해주세요.'
                    },
                    {
                      pattern: new RegExp(/(\S){1}/g),
                      // new RegExp(/^[A-Za-z\s][A-Za-z0-9\s\&\,\(\)\.]*$/)
                      message: '공백만 입력하지 마세요.'
                    }
                  ]}
                >
                  <Input maxLength={20} disabled />
                </Form.Item>
                <Form.Item
                  label="구매자 이메일"
                  name="buyerEmail"
                  style={{ justifyItems: 'center', padding: '0 1rem' }}
                  rules={[
                    {
                      type: 'email',
                      message: '입력하신 이메일이 유효하지 않습니다!'
                    },
                    {
                      required: true,
                      message: '이메일은 필수 입력 조건입니다.'
                    }
                  ]}
                >
                  <Input maxLength={70} disabled />
                </Form.Item>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                  paddingBottom: '1rem',
                  borderBottom: '1px solid #f0f2f5'
                }}
              >
                <div>
                  <Form.Item
                    label="수취자 이름"
                    name="recipientName"
                    style={{ justifyItems: 'center', padding: '0 1rem' }}
                    rules={[
                      {
                        required: true,
                        message: '수취자 이름은 필수 입력 조건입니다.'
                      }
                    ]}
                  >
                    <Input maxLength={20} disabled />
                  </Form.Item>
                  <Form.Item
                    label="수취자 연락처"
                    name="recipientPhone"
                    style={{ justifyItems: 'center', padding: '0 1rem' }}
                    rules={[
                      {
                        required: true,
                        message: '수취자 이름은 필수 입력 조건입니다.'
                      }
                    ]}
                  >
                    <Input addonBefore={`+${callingCode}`} disabled />
                  </Form.Item>
                </div>
                <div
                  style={{
                    gridColumn: 'span 2 / span 2',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))'
                  }}
                >
                  <Form.Item
                    name="country"
                    label="배송 국가/주소"
                    style={{
                      justifyItems: 'center',
                      gridColumn: 'span 2 / span 2',
                      padding: '0 1rem 0.5rem 1rem'
                    }}
                    rules={[
                      {
                        required: true,
                        message: '배송 국가/주소 입력해주세요.'
                      }
                    ]}
                  >
                    <Input disabled placeholder="Country" />
                  </Form.Item>
                  <Form.Item
                    label=" "
                    name="shippingAddress"
                    style={{
                      justifyItems: 'center',
                      gridColumn: 'span 4 / span 4',
                      padding: '0 1rem 0.5rem 1rem'
                    }}
                    rules={[
                      {
                        required: false,
                        message: '배송 주소를 입력해주세요.'
                      },
                      {
                        pattern: new RegExp(
                          /^[A-Za-z0-9\s][A-Za-z0-9\s\&\,\-\@\!\#\+\(\)\.]*$/
                        ),
                        message: '영문만 입력 가능'
                      }
                    ]}
                  >
                    <div ref={ref}>
                      <Input
                        className="border-input"
                        value={searchValue}
                        onChange={handleInput}
                        placeholder="Search Places ..."
                        disabled
                      />
                      {status === 'OK' && <ul>{renderSuggestions()}</ul>}
                    </div>
                  </Form.Item>
                  <Form.Item
                    name="detailAddress2"
                    style={{
                      justifyItems: 'center',
                      paddingLeft: '1rem',
                      gridColumn: 'span 3 / span 3'
                    }}
                  >
                    <Input disabled placeholder="More detail adress" />
                  </Form.Item>
                  <Form.Item
                    name="detailAddress"
                    style={{
                      justifyItems: 'center',
                      paddingLeft: '1rem',
                      gridColumn: 'span 3 / span 3'
                    }}
                  >
                    <Input
                      disabled
                      placeholder="Apartment, suite, unite, building, floor, etc."
                    />
                  </Form.Item>
                  <Form.Item
                    name="city"
                    style={{
                      justifyItems: 'center',
                      paddingLeft: '1rem',
                      paddingTop: '0.5rem',
                      gridColumn: 'span 2 / span 2'
                    }}
                  >
                    <Input disabled placeholder="Town/City" />
                  </Form.Item>
                  <Form.Item
                    name="state"
                    style={{
                      justifyItems: 'center',
                      paddingLeft: '1rem',
                      paddingTop: '0.5rem',
                      gridColumn: 'span 2 / span 2'
                    }}
                  >
                    <Input disabled placeholder="County/State" />
                  </Form.Item>
                  <Form.Item
                    name="postalCode"
                    style={{
                      justifyItems: 'center',
                      paddingLeft: '1rem',
                      paddingTop: '0.5rem',
                      gridColumn: 'span 2 / span 2'
                    }}
                  >
                    <Input disabled placeholder="Post code" />
                  </Form.Item>
                </div>
              </div>
              <div>
                <div
                  style={{
                    padding: '0.5rem',
                    margin: '1rem',
                    backgroundColor: '#F9F9F9',
                    borderRadius: '1rem'
                  }}
                >
                  <Form.List name="product">
                    {(fields, { add, remove }) => {
                      return (
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(13, minmax(0, 1fr))',
                            gap: '1rem'
                          }}
                        >
                          <div
                            style={{
                              justifyItems: 'center',
                              gridColumn: 'span 13 / span 13'
                            }}
                          >
                            {(fields || []).map((field, index, ...rest) => (
                              <div
                                style={{
                                  display: 'flex',
                                  marginBottom: '1rem'
                                }}
                                key={index}
                              >
                                <Form.Item
                                  label="id"
                                  name={[field.name, 'id']}
                                  style={{
                                    justifyItems: 'center',
                                    padding: '0 1rem',
                                    width: '20%',
                                    display: 'none'
                                  }}
                                >
                                  <Input disabled />
                                </Form.Item>
                                <Form.Item
                                  label="상품명"
                                  name={[field.name, 'productName']}
                                  style={{
                                    justifyItems: 'center',
                                    padding: '0 1rem',
                                    width: '40%'
                                  }}
                                >
                                  <AutoComplete
                                    style={{ width: '100%' }}
                                    getPopupContainer={(node) => node}
                                    options={suggestProduct}
                                    onSearch={(e) => {
                                      setInputProduct(e);
                                      setIndexProduct(index);
                                    }}
                                    onFocus={(e: any) => {
                                      setIndexProduct(index);
                                      // if(!e.target?.value){
                                      //     getListProduct(idWarehouse,'')
                                      // }
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="SKU"
                                  name={[field.name, 'sku']}
                                  style={{
                                    justifyItems: 'center',
                                    padding: '0 1rem',
                                    width: '25%'
                                  }}
                                >
                                  <Input disabled />
                                </Form.Item>
                                {channel !== 'Amazons' ? (
                                  <Form.Item
                                    label="EAN/UPC"
                                    name={[field.name, 'eanUpc']}
                                    style={{
                                      justifyItems: 'center',
                                      padding: '0 1rem',
                                      width: '25%'
                                    }}
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                ) : (
                                  <Form.Item
                                    label="ASIN"
                                    name={[field.name, 'asin']}
                                    style={{
                                      justifyItems: 'center',
                                      padding: '0 1rem',
                                      width: '25%'
                                    }}
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                )}
                                <Form.Item
                                  label="수량"
                                  name={[field.name, 'orderQuantity']}
                                  style={{
                                    justifyItems: 'center',
                                    padding: '0 1rem',
                                    width: '10%'
                                  }}
                                >
                                  <InputNumber
                                    max={remainQuantity[index]}
                                    min={0}
                                    disabled
                                  />
                                </Form.Item>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    }}
                  </Form.List>
                </div>
                <div style={{ borderBottom: '1px solid #f0f2f5' }}></div>
                <div>
                  <div style={{ display: 'flex', marginBottom: '1rem' }}>
                    <div
                      style={{
                        justifyItems: 'center',
                        padding: '0 1rem',
                        width: '20%'
                      }}
                    >
                      <Form.Item label="포장 방법" name="packagingMethod">
                        <Select
                          mode="multiple"
                          showArrow
                          placeholder="Select"
                          getPopupContainer={(node) => node}
                          onChange={(e: any) => {
                            if (e.includes('Directinput')) {
                              form.setFieldsValue({
                                packagingMethod: 'Directinput'
                              });
                              setSelectUse(false);
                            } else {
                              setSelectUse(true);
                            }
                          }}
                          disabled
                        >
                          {!!selectUse ? (
                            <>
                              <Select.Option value="Unnecessary">
                                Unnecessary
                              </Select.Option>
                              <Select.Option value="Carton box">
                                {' '}
                                Carton box
                              </Select.Option>
                              <Select.Option value="Poly mailer">
                                Poly mailer{' '}
                              </Select.Option>
                              <Select.Option value="Bubble mailer">
                                {' '}
                                Bubble mailer
                              </Select.Option>
                              <Select.Option value="Compression">
                                Compression
                              </Select.Option>
                              <Select.Option value="Airpack">
                                Airpack
                              </Select.Option>
                              <Select.Option value="Icepack">
                                Icepack
                              </Select.Option>
                              <Select.Option value="Envelope">
                                Envelope
                              </Select.Option>
                              <Select.Option value="Bubble wrap">
                                Bubble wrap
                              </Select.Option>
                              <Select.Option value="Directinput">
                                Direct input{' '}
                              </Select.Option>
                            </>
                          ) : (
                            <Select.Option value="Directinput">
                              Direct input{' '}
                            </Select.Option>
                          )}
                        </Select>
                      </Form.Item>
                      {!selectUse && (
                        <Form.Item
                          name="packageInput"
                          style={{ padding: '0.25rem 2.125rem 0 0' }}
                        >
                          <Input disabled />
                        </Form.Item>
                      )}
                    </div>
                    <Form.Item
                      label="위험 물품 포함 여부"
                      name="dangerous"
                      style={{
                        justifyItems: 'center',
                        padding: '0 1rem',
                        width: '20%'
                      }}
                      rules={[
                        {
                          required: true,
                          message: '제품이 위험합니까?'
                        }
                      ]}
                    >
                      <Select
                        placeholder="Select"
                        disabled
                        getPopupContainer={(node) => node}
                      >
                        <Select.Option value="2">No</Select.Option>
                        <Select.Option value="1">Yes</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="배송 방법"
                      name="shippingMethod"
                      style={{
                        justifyItems: 'center',
                        padding: '0 1rem',
                        width: '20%'
                      }}
                      rules={[
                        {
                          required: true,
                          message: '배송방법을 선택해주세요'
                        }
                      ]}
                    >
                      <Select
                        placeholder="Select"
                        getPopupContainer={(node) => node}
                        disabled
                      >
                        <Select.Option value="Economic">Economic</Select.Option>
                        <Select.Option value="Standard">Standard</Select.Option>
                        <Select.Option value="Express">Express</Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div style={{ display: 'flex', marginBottom: '1rem' }}>
                    <div style={{ width: '100%' }}>
                      <Form.Item
                        name="sellerComment"
                        style={{
                          justifyItems: 'center',
                          padding: '0 1rem',
                          width: '100%'
                        }}
                      >
                        <Input.TextArea
                          style={{ padding: '2rem 1rem 1rem 1rem' }}
                          disabled
                        />
                      </Form.Item>
                      <div
                        style={{
                          position: 'relative',
                          left: '1.5rem',
                          bottom: '5.5rem',
                          zIndex: '10',
                          fontWeight: 'bold'
                        }}
                      >
                        물류센터에게 보내는 코멘트
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tableTrack-shipping"
                  style={{
                    display: info.courier ? '' : 'none'
                  }}
                >
                  <div className="ant-table">
                    <div className="ant-table-container">
                      <div className="ant-table-content">
                        <table style={{ tableLayout: 'auto' }}>
                          <thead className="ant-table-thead">
                            <tr>
                              <th className="ant-table-cell">Update Date</th>
                              <th className="ant-table-cell">Courier</th>
                              <th className="ant-table-cell">
                                Tracking Number
                              </th>
                              <th className="ant-table-cell">Status</th>
                              <th className="ant-table-cell">
                                Comment from Warehouse
                              </th>
                            </tr>
                          </thead>
                          <tbody className="ant-table-tbody">
                            <tr
                              data-row-key="1"
                              className="ant-table-row ant-table-row-level-0"
                            >
                              <td className="ant-table-cell">
                                <p>{formatDateTime(info?.updated_at)}</p>
                              </td>
                              <td className="ant-table-cell">
                                {' '}
                                <Input
                                  disabled
                                  value={info.courier}
                                  style={{ resize: 'none' }}
                                />
                              </td>
                              <td className="ant-table-cell">
                                {' '}
                                <Input
                                  disabled
                                  value={info.trackingNumber}
                                  style={{ resize: 'none' }}
                                />
                              </td>
                              <td className="ant-table-cell"> {info.status}</td>
                              <td className="ant-table-cell">
                                {' '}
                                <Input.TextArea
                                  value={info.commentWarehouse}
                                  style={{ resize: 'none' }}
                                  cols={4}
                                  disabled
                                  // maxLength={150}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{ display: info.status === '배송요청' ? '' : 'none' }}
                >
                  <CommentTabsComponent
                    onSend={onSendComment}
                    tabs={tabs}
                    commentList={commentList!}
                    refectComments={getCommentList}
                    itemId={shippingid}
                    commentGroup={CommentGroup.DELIVERY_DETAIL}
                    removeItem={removeShipping}
                    removeTitle="배송 신청 내용을 삭제 하시겠습니까?"
                  />
                </div>
                <div className="container-tag-button">
                  <div className="tag-button">
                    <div className="button-container">
                      <Button
                        type="default"
                        onClick={() => {
                          history.push({
                            pathname: `/admin/seller/shipping/create-return`,
                            state: {
                              idOrder: shippingid,
                              stockName: info.name
                            }
                          });
                        }}
                        disabled={info.status !== '배송완료' || returnExists}
                      >
                        반품 요청
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Card>
      </div>
      <Modal
        width={400}
        visible={isShowErrorModal}
        onOk={() => {
          setIsShowErrorModal(false);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={() => {
          setIsShowErrorModal(false);
        }}
        okButtonProps={{
          style: {
            padding: '.5rem 2.5rem',
            height: 'auto',
            border: 'none',
            borderRadius: '7.25px',
            backgroundColor: '#2B2C51',
            display: 'inline-block'
          }
        }}
        okText="확인"
        maskClosable={true}
      >
        <div>
          현재 송장을 다운로드 할 수 있는 상태가 아닙니다. Shopee 사이트를
          확인해주세요.
        </div>
      </Modal>
    </>
  );
};
export default ShippingDetail;
